import { SVGProps, Ref, forwardRef } from 'react';

export const FacebookSolidSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M13.333 22.916C18.78 22.258 23 17.62 23 11.996c0-6.075-4.925-11-11-11s-11 4.925-11 11c0 5.16 3.551 9.489 8.342 10.677v-7.315h-2.27v-3.362h2.27v-1.452c0-3.744 1.694-5.478 5.368-5.478.696 0 1.897.137 2.39.273v3.05c-.26-.027-.713-.04-1.272-.04-1.804 0-2.5.682-2.5 2.46v1.187h3.596l-.616 3.362h-2.975z"
                fill="currentColor"
            />
        </g>
    </svg>
));
FacebookSolidSize24Glyph.displayName = 'FacebookSolidSize24Glyph';
